import { render, staticRenderFns } from "./Passenger.vue?vue&type=template&id=66770074&scoped=true"
import script from "./Passenger.vue?vue&type=script&lang=js"
export * from "./Passenger.vue?vue&type=script&lang=js"
import style0 from "./Passenger.vue?vue&type=style&index=0&id=66770074&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66770074",
  null
  
)

export default component.exports